<template>
  <div class="page-header" :class="isH5 ? 'h5-page-header' : 'pc-page-header'">
    <p class="title">
      <img
        @click="goBack"
        class="back"
        src="../../../assets/images/arrow-left.png"
        alt=""
      />
      <span> {{ title }}</span>
    </p>
  </div>
</template>

<script>
import { isHXApp, isH5 } from "@saas/components";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      isHXApp: isHXApp(),
      isH5: isH5(),
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-page-header {
  width: 100%;
  background: #ffffff;
  .back {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    width: 9px;
    height: auto;
    cursor: pointer;
  }
  .title {
    max-width: 800px;
    width: 100%;
    height: 70px;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      padding: 0 30px;
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
.h5-page-header {
  width: 100%;
  background: #f7f8f9;
  .back {
    position: absolute;
    left: 0.45rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0.24rem;
    height: auto;
  }
  .title {
    position: relative;
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      padding: 0 1.1rem;
      font-weight: 400;
      font-size: 0.43rem;
      color: #0d1400;
      line-height: 0.6rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}
</style>
